import React from 'react';
import FaIcon from '../../Elements/FaIcon.js';

class SelectLink extends React.Component {
  static defaultProps = {
    disabled: false,
  };

  showLabelingTextMaxLength = 23;

  formatLabeling(text) {
    if (text == null || text.length < 1) {
      return '';
    } else {
      return text.length > this.showLabelingTextMaxLength
        ? `${text.substring(0, this.showLabelingTextMaxLength)}...`
        : text;
    }
  }

  render() {
    const shown = this.formatLabeling(this.props.shownName);

    return (
      <div
        className='ae-link'
        data-toggle={this.props.dataToggle}
      >
        <span className='lk'>{this.props.labelText}</span>
        <span
          className={`lv${this.props.disabled ? ' lv-off' : ''}`}
          style={this.props.style}
          onClick={this.props.disabled ? undefined : this.props.onClick}
          data-toggle={this.props.dataToggle}
          data-placement='top'
          title=''
        >
          {shown ? (
            <span className='set'>{shown}</span>
          ) : this.props.disabled ? (
            <span className='set' />
          ) : (
            <button
              type='button'
              className='pick'
            >
              Select…
            </button>
          )}
        </span>
        <button
          type='button'
          className='clr'
          disabled={this.props.disabled || !shown}
          onClick={this.props.deselectOnClick}
          aria-label={`Clear ${this.props.labelText}`}
        >
          <FaIcon iconName='fa-solid fa-xmark' />
        </button>
      </div>
    );
  }
}

export default SelectLink;
